import { SxProps, Theme } from '@mui/material';

export const containerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  padding: '24px 8px',
  backgroundColor: 'transparent',
};

export const containerWithBorderStyles: SxProps<Theme> = {
  border: '1px dashed',
  borderColor: (theme) => theme.palette.M3.sys.light.outline,
  borderRadius: 3,
};

export const textContainerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 4,
  textAlign: 'center',
  maxWidth: 458,
};

export const titleStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.M3.sys.light['on-primary-fixed'],
  fontWeight: 600,
  fontSize: '22px',
  lineHeight: '28px',
};

export const descriptionStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.M3.sys.light['on-surface-variant'],
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.25px',
};

export const buttonStyles: SxProps<Theme> = {
  minWidth: 164,
  height: 40,
};
